import React from 'react';
import PropTypes from 'prop-types';

const AnimalProperty = ({ properties }) => (
  <div className={`animal-property property-${properties.icon}`}>
    <div className="property-name">{properties.title}</div>
    <div className="property-description" dangerouslySetInnerHTML={{ __html: properties.description }} />
  </div>
);

AnimalProperty.propTypes = {
  properties: PropTypes.object
};

export default AnimalProperty;
